(function () {
   if (window.VariantSelectionPopupInitialized) return;
   window.VariantSelectionPopupInitialized = true;

   var popup = null;
   var qtyInput = null;
   var currentProductData = null;
   var selectedOptions = {};

   function createPopupHTML() {
      var div = document.createElement('div');
      div.id = 'VariantSelectionPopup';
      div.className = 'variant-popup hidden';
      div.setAttribute('aria-hidden', 'true');
      div.setAttribute('role', 'dialog');
      div.innerHTML =
         '<div class="variant-popup__overlay" data-close></div>' +
         '<div class="variant-popup__content">' +
         '<div class="variant-popup__header">' +
         '<div class="variant-popup__header-text">' +
         '<h2 class="variant-popup__title">Selecteer uw optie</h2>' +
         '<p class="variant-popup__subtitle"></p>' +
         '</div>' +
         '<button class="variant-popup__close" aria-label="Close" data-close>' +
         '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
         '</button>' +
         '</div>' +
         '<div class="variant-popup__body">' +
         '<div class="variant-popup__options-container"></div>' +
         '</div>' +
         '<div class="variant-popup__footer">' +
         '<div class="variant-popup__quantity">' +
         '<button class="minus" type="button" aria-label="Decrease quantity">-</button>' +
         '<input type="number" id="VariantPopupQuantity" name="quantity" class="qty" value="1" min="1" aria-label="Quantity">' +
         '<button class="plus" type="button" aria-label="Increase quantity">+</button>' +
         '</div>' +
         '<div class="variant-popup__cta">' +
         '<button type="button" class="variant-popup__submit-btn">' +
         '<span class="variant-popup__submit-text">IN WINKELWAGEN</span>' +
         '<span class="loading-overlay__spinner hidden">' +
         '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
         '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
         '</svg>' +
         '</span>' +
         '</button>' +
         '</div>' +
         '</div>' +
         '</div>';
      document.body.appendChild(div);
      return div;
   }

   function initPopupElements() {
      if (!popup) {
         popup = document.getElementById('VariantSelectionPopup');
         if (!popup) {
            popup = createPopupHTML();
         }
         if (popup) {
            // Move to body to escape any hidden tabs, overflow:hidden or transform stacking contexts
            if (popup.parentElement !== document.body) {
               document.body.appendChild(popup);
            }

            qtyInput = popup.querySelector('#VariantPopupQuantity');

            popup.addEventListener('click', function (e) {
               if (e.target.hasAttribute('data-close') || e.target.closest('[data-close]')) {
                  closePopup();
               }
            });

            var btnMinus = popup.querySelector('.minus');
            if (btnMinus) {
               btnMinus.addEventListener('click', function () {
                  if (!qtyInput) return;
                  var v = parseInt(qtyInput.value, 10);
                  if (!isNaN(v) && v > 1) qtyInput.value = v - 1;
               });
            }

            var btnPlus = popup.querySelector('.plus');
            if (btnPlus) {
               btnPlus.addEventListener('click', function () {
                  if (!qtyInput) return;
                  var v = parseInt(qtyInput.value, 10);
                  if (!isNaN(v)) qtyInput.value = v + 1;
               });
            }

            var submitBtn = popup.querySelector('.variant-popup__submit-btn');
            if (submitBtn) {
               submitBtn.addEventListener('click', function () {
                  if (submitBtn.disabled) return;
                  var variantId = submitBtn.dataset.variantId || submitBtn.getAttribute('data-variant-id');
                  var qtyVal = qtyInput ? qtyInput.value : "1";
                  var qty = parseInt(qtyVal, 10);
                  if (isNaN(qty) || qty < 1) qty = 1;

                  var spinner = submitBtn.querySelector('.loading-overlay__spinner');
                  var btnText = submitBtn.querySelector('.variant-popup__submit-text');

                  if (spinner) spinner.classList.remove('hidden');
                  if (btnText) btnText.style.opacity = '0';

                  try {
                     var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ? window.theme.routes.cart_add_url + '.js' : '/cart/add.js';
                     fetch(cartAddUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
                     })
                        .then(function (res) { return res.json(); })
                        .then(function (data) {
                           if (!data.status) {
                              // Fire cart:item-added so Meta Pixel tracks AddToCart
                              dispatchCustomEvent('cart:item-added', {
                                 product: data.hasOwnProperty('items') ? data.items[0] : data
                              });

                              dispatchCustomEvent('cart:refresh');

                              var cartDrawer = document.getElementById('Cart-Drawer');
                              if (cartDrawer) {
                                 document.body.classList.add('open-cc');
                                 document.body.classList.add('open-cart');
                                 cartDrawer.classList.add('active');
                                 if (cartDrawer.querySelector('.product-recommendations--full')) {
                                    cartDrawer.querySelector('.product-recommendations--full').classList.add('active');
                                 }
                              }
                              closePopup();
                           } else {
                              console.error('Variant Popup: Add to cart error:', data);
                           }
                        })
                        .catch(function (err) { console.error('Variant Popup Fetch Error:', err); })
                        .finally(function () {
                           if (spinner) spinner.classList.add('hidden');
                           if (btnText) btnText.style.opacity = '1';
                           if (qtyInput) qtyInput.value = 1;
                        });
                  } catch (err) {
                     console.error('Variant Popup error:', err);
                     if (spinner) spinner.classList.add('hidden');
                     if (btnText) btnText.style.opacity = '1';
                  }
               });
            }
         }
      }
      return popup;
   }

   // Use document.body to safely capture all bubbled clicks in case document fails in weird iframe/theme setups
   document.addEventListener('click', function (e) {
      try {
         var addButton = e.target.closest('.upsell-product-card__add-btn, .cart-upsell-add-btn');
         if (addButton) {
            var hasMultipleVariants = addButton.getAttribute('data-has-multiple-variants') || addButton.dataset.hasMultipleVariants;
            if (hasMultipleVariants && hasMultipleVariants.trim() === 'true') {
               e.preventDefault();
               e.stopPropagation();
               openPopup(addButton);
            }
         }
      } catch (err) {
         console.error('Variant popup click handler error:', err);
      }
   });

   window.openVariantSelectionPopup = openPopup;
   function openPopup(btn) {
      if (!initPopupElements()) {
         console.error('Variant Popup: Could not create popup.');
         return;
      }

      var handle = btn.getAttribute('data-handle');
      if (!handle) {
         console.error('Variant Popup: data-handle not found on button.');
         return;
      }

      btn.classList.add('loading');
      var btnText = btn.querySelector('.btn-text') || btn.querySelector('.upsell-product-card__add-btn-text');
      if (btnText) btnText.style.opacity = '0';

      fetch('/products/' + handle + '.js')
         .then(function (res) { return res.json(); })
         .then(function (productData) {
            currentProductData = productData;
            selectedOptions = {};

            var firstAvailable = currentProductData.variants[0];
            for (var i = 0; i < currentProductData.variants.length; i++) {
               if (currentProductData.variants[i].available) {
                  firstAvailable = currentProductData.variants[i];
                  break;
               }
            }

            if (firstAvailable && firstAvailable.options) {
               firstAvailable.options.forEach(function (opt, idx) {
                  selectedOptions['option' + (idx + 1)] = opt;
               });
            }

            if (qtyInput) qtyInput.value = 1;

            renderPopupContent();
            popup.classList.remove('hidden');
            popup.setAttribute('aria-hidden', 'false');
            popup.classList.add('is-open');
            document.body.style.overflow = 'hidden';
         })
         .catch(function (err) {
            console.error('Variant Popup Fetch Error:', err);
         })
         .finally(function () {
            btn.classList.remove('loading');
            if (btnText) btnText.style.opacity = '1';
         });
   }

   function closePopup() {
      if (popup) {
         popup.classList.remove('is-open');
         popup.setAttribute('aria-hidden', 'true');
         popup.classList.add('hidden');
         document.body.style.overflow = '';
      }
   }

   function renderPopupContent() {
      var titleEl = popup.querySelector('.variant-popup__title');
      if (titleEl) titleEl.textContent = currentProductData.title || '';

      var optionsContainer = popup.querySelector('.variant-popup__options-container');
      if (!optionsContainer) return;
      optionsContainer.innerHTML = '';

      if (!currentProductData.options || !Array.isArray(currentProductData.options)) return;

      currentProductData.options.forEach(function (option, idx) {
         var optionKey = 'option' + (idx + 1);

         var groupDiv = document.createElement('div');
         groupDiv.className = 'variant-popup__option-group';

         var groupName = document.createElement('div');
         groupName.className = 'variant-popup__option-name';
         groupName.textContent = option.name;
         groupDiv.appendChild(groupName);

         var listDiv = document.createElement('div');
         listDiv.className = 'variant-popup__options-list';

         if (option.values && Array.isArray(option.values)) {
            option.values.forEach(function (val) {
               var swatchBtn = document.createElement('button');
               swatchBtn.type = 'button';
               swatchBtn.className = 'variant-popup__swatch';
               if (selectedOptions[optionKey] === val) {
                  swatchBtn.classList.add('is-active');
               }

               var colorNameLower = val.toLowerCase();
               var colors = {
                  'mauve': '#cdaaa6',
                  'gold': '#e8d5b5',
                  'champagne': '#dcbba5',
                  'bronze': '#9a6b5d',
                  'pearl': '#e9e3df',
                  'dusty rose': '#d48a94',
                  'pink peony': '#b75b7b',
                  'grape galore': '#8b5e80',
                  'zwart': '#000000',
                  'wit': '#ffffff',
                  'roze': '#ffd1dc',
                  'blauw': '#a1caf1',
                  'taupe': '#483c32',
                  'rood': '#ff3838ff',
                  'zilver': '#c0c0c0ff'
               };

               var optNameLower = option.name.toLowerCase();
               var isColorOption = optNameLower.indexOf('color') > -1 || optNameLower.indexOf('kleur') > -1 || Object.prototype.hasOwnProperty.call(colors, colorNameLower);

               if (isColorOption && colors[colorNameLower]) {
                  var swatchColor = document.createElement('div');
                  swatchColor.className = 'variant-popup__swatch-color';
                  swatchColor.style.backgroundColor = colors[colorNameLower];
                  swatchBtn.appendChild(swatchColor);
               }

               var label = document.createElement('span');
               label.className = 'variant-popup__swatch-label';
               label.textContent = val;
               swatchBtn.appendChild(label);

               swatchBtn.addEventListener('click', function () {
                  selectedOptions[optionKey] = val;
                  updateVariantState();
               });

               listDiv.appendChild(swatchBtn);
            });
         }
         groupDiv.appendChild(listDiv);
         optionsContainer.appendChild(groupDiv);
      });

      updateVariantState();
   }

   function updateVariantState() {
      var groups = popup.querySelectorAll('.variant-popup__option-group');
      currentProductData.options.forEach(function (option, idx) {
         var optionKey = 'option' + (idx + 1);
         var selectedVal = selectedOptions[optionKey];
         if (groups[idx]) {
            var swatches = groups[idx].querySelectorAll('.variant-popup__swatch');
            swatches.forEach(function (swatch, sIdx) {
               var val = option.values[sIdx];
               if (val === selectedVal) {
                  swatch.classList.add('is-active');
               } else {
                  swatch.classList.remove('is-active');
               }
            });
         }
      });

      var matchedVariant = null;
      if (currentProductData.variants && Array.isArray(currentProductData.variants)) {
         for (var i = 0; i < currentProductData.variants.length; i++) {
            var v = currentProductData.variants[i];
            var match = true;
            for (var j = 0; j < currentProductData.options.length; j++) {
               var optKey = 'option' + (j + 1);
               if (v[optKey] !== selectedOptions[optKey]) {
                  match = false;
                  break;
               }
            }
            if (match) {
               matchedVariant = v;
               break;
            }
         }
      }

      var submitBtn = popup.querySelector('.variant-popup__submit-btn');
      var submitText = popup.querySelector('.variant-popup__submit-text');
      if (!submitBtn || !submitText) return;

      if (matchedVariant) {
         if (matchedVariant.available) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-disabled');
            submitBtn.setAttribute('data-variant-id', matchedVariant.id);
            submitBtn.dataset.variantId = matchedVariant.id;
            submitText.textContent = 'IN WINKELWAGEN';
         } else {
            submitBtn.disabled = true;
            submitBtn.classList.add('is-disabled');
            submitText.textContent = 'UITVERKOCHT';
         }
      } else {
         submitBtn.disabled = true;
         submitBtn.classList.add('is-disabled');
         submitText.textContent = 'NIET BESCHIKBAAR';
      }
   }
})();
